export const CustomRangeConfig = {
    off: "off",
    date: "date",
    dateTime: "dateTime",
} as const;
export type CustomRangeConfig = (typeof CustomRangeConfig)[keyof typeof CustomRangeConfig];
